// START IMPORTS
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { GrowthbookWrapper, useSession } from '@ltvco/refresh-lib/v1';
import { useEffect, useState } from 'react';

import { ThemeWrapper } from './ThemeWrapper';
// END IMPORTS

export function Growthbook({ children }: { children: JSX.Element }) {
  // START HOOKS_AND_QUERIES
  const {
    session: { account },
  } = useSession();
  const { isMobile } = useScreenSize();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [customAttributes, setCustomAttributes] = useState<
    Record<string, unknown>
  >({});
  const [isGbReady, setIsGbReady] = useState(false);
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const isTestingEnv = import.meta.env.VITE_IS_TEST;
  const deviceType = isMobile ? 'web-mobile' : 'desktop';
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    if (!account) {
      return;
    }
    setCustomAttributes({
      'device-type': deviceType,
      pdf_access:
        !!account?.account?.subscription_info?.subscription_features
          ?.pdf_access,
      is_user_in_recycling: account?.account?.user_info?.user_in_recycling,
      is_user_mobile_subscription:
        account?.account?.subscription_info['mobile_subscription?'],
    });
  }, [account]);
  // END EFFECTS

  // START EARLY_RETURNS
  if (isTestingEnv) {
    return <ThemeWrapper isGbReady={isGbReady}>{children}</ThemeWrapper>;
  }
  // END EARLY_RETURNS

  // START RENDER
  return (
    <GrowthbookWrapper
      enableDevMode={true}
      apiHost={'https://gbbv.beenverified.com'}
      clientKey={'sdk-sH9Cly3zfuFM9mdc'}
      decryptionKey={'nZwGIW+xki4yOM6qBBx8Kg=='}
      subscribeToChanges={false}
      customAttributes={customAttributes}
      setIsGbReady={setIsGbReady}
      brandName={'beenverified'}
    >
      <ThemeWrapper isGbReady={isGbReady}>{children}</ThemeWrapper>
    </GrowthbookWrapper>
  );
  // END RENDER
}
